import {
  create_staff_title,
  update_staff_title,
  delete_staff_title,
  recover_staff_title,
  query_staff_title_list,
} from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/mjstore/mjstore-shop-config';

import { reactive } from 'vue';
import {get_is_active, get_is_active2} from "@/utils/function";

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'name',
      label: '职位名称',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写职位名称',
    },
    {
      type: 'remoteselect',
      name: 'shop_type_id',
      label: '门店类型',
      disabled: false,
      placeholder: '请选择门店类型',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shoptype',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    name: null,
    area_id: null,
    person_id: null,
    phone: null,
    address: null,
    person_name: null,
    person_phone: null,
    code: null,
  }),
};
const search_options = {
  is_active: [
    { value: None, name: '全部' },
    {
      value: True,
      name: '可用',
    },
    { value: False, name: '作废' },
  ],
};

const edit_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
    labelCol: {
      span: 5,
    },
    wrapperCol: {
      span: 19,
    },
  },
  fields: [
    {
      type: 'input',
      name: 'name',
      label: '职位名称',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写职位名称',
    },
    {
      type: 'remoteselect',
      name: 'shop_type_id',
      label: '门店类型',
      disabled: false,
      placeholder: '请选择门店类型',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shoptype',
    },
  ],
  rules: {
    name: [{ required: true, message: '请填输入职位名称' }],
    shop_type_id: [{ required: true, message: '请填选择门店类型' }],
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    name: null,
    phone: null,
    person_id: null,
    code: null,
    area_id: null,
    birthday: null,
  }),
};
const edit_model_config_options = {};

const update_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
    labelCol: {
      span: 5,
    },
    wrapperCol: {
      span: 19,
    },
  },
  fields: [
    {
      type: 'input',
      name: 'name',
      label: '职位名称',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写职位名称',
    },
    {
      type: 'remoteselect',
      name: 'shop_type_id',
      label: '门店类型',
      disabled: false,
      placeholder: '请选择门店类型',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shoptype',
    },
  ],
  rules: {
    name: [{ required: true, message: '请填输入职位名称' }],
    shop_type_id: [{ required: true, message: '请填选择门店类型' }],
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    name: null,
    shop_type_id: null,
  }),
};
const update_model_config_options = {};

const titleList = {
  title: '职位管理',
  addModalTitle: '新建职位',
  updateTitle: '修改职位',
  is_create: true, // 是否有【新建】按钮
  is_update: true, // 是否有【修改】按钮
  is_remove: true, // 是否有【删除】按钮
  is_recover: true, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    staff_title_id: 'id',
  },
  delete: {
    staff_title_id: 'id',
  },
  recover: {
    staff_title_id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    staff_title_id: 'id',
  },
};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
  },
  {
    title: '职位名称',
    dataIndex: 'name',
    width: 100,
    checked: true,
  },
  {
    title: '门店类型',
    dataIndex: 'shop_type__name',
    width: 100,
    checked: true,
  },
  {
    title: '操作',
    width: 200,
    dataIndex: 'is_active',
    checked: true,
    cellComponent: 'action',
    fixed: 'right',
    filterMultiple: false,
    filters: [
      { text: '全部', value: '' },
      { text: '可用', value: true },
      { text: '作废', value: false },
    ],
    content: (record: any, text: any) => {
      return get_is_active2(text);
    },
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
newSlotList.push({
  type: 'custom',
  // slotName: 'is_active',
  field_true: '可用',
  field_false: '作废',
});

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_staff_title_list,
    addData: create_staff_title,
    updateData: update_staff_title,
    removeData: delete_staff_title,
    recoverData: recover_staff_title,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
